import { styled } from '@mui/material/styles'

import { Box, Button, Typography } from '@mui/material'

export const Colors = {
  primary: '#00bcd4',
  primaryHover: '#00acc1',
  error: '#f44336',
  darkBackground: '#0a0a1f',
  darkBackgroundHover: '#1a1a2e',
  borderColor: '#2a2a4a',
}

export const StyledContainer = styled(Box)({
  padding: '24px',
  color: 'white',
  backgroundColor: '#0d0d0d',
})

// Cards UI section
export const FilterContainer = styled(Box)({
  display: 'flex',
  gap: '12px',
  padding: '20px',
  justifyContent: 'center',
})

export const FilterButton = styled(Button)({
  padding: '6px 11px',
  borderRadius: '14.5px',
  backgroundColor: '#251e0f',
  fontFamily: 'Alexandria',
  fontWeight: '400',
  fontSize: '13px',
  lineHeight: '15.85px',
  letterSpacing: '1.63px',
  textAlign: 'center',
  color: '#feb820',
  opacity: '1',
  textTransform: 'uppercase',
  '&:hover': {
    backgroundColor: 'rgba(255, 255, 255, 0.2)',
  },
})

export const CardGridWrapper = styled(Box)({
  backgroundColor: '#0d0d0d',
})

export const CardGrid = styled(Box)({
  columnCount: 3,
  columnGap: '66px',
  margin: '0 auto',
  width: 'fit-content',
  paddingTop: '40px',
  paddingBottom: '40px',
  '@media (max-width: 1476px)': {
    columnCount: 2,
  },
  '@media (max-width: 1068px)': {
    columnCount: 1,
  },
  '@media (max-width: 600px)': {
    columnGap: '16px',
    paddingTop: '20px',
    paddingBottom: '20px',
    width: '100%',
    paddingLeft: '16px',
    paddingRight: '16px',
    boxSizing: 'border-box',
  },
})

export const CardWrapper = styled(Box)({
  width: 'min(349px, 100%)',
  breakInside: 'avoid',
  pageBreakInside: 'avoid',
  marginBottom: '66px',
  '@media (max-width: 600px)': {
    marginBottom: '24px',
  },
})

export const SocialCard = styled(Box)({
  position: 'relative',
  borderRadius: '24px',
  overflow: 'hidden',
  backgroundColor: '#ffffff',
  height: 'auto',
  width: '100%',
  maxWidth: '349px',
  boxShadow: '4px 8px 20px 0px #FFFFFF40',
  '@media (max-width: 600px)': {
    maxWidth: '100%',
  },
})

export const CardHeader = styled(Box)({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  padding: '16px',
  position: 'absolute',
  top: 0,
  left: 0,
  right: 0,
  zIndex: 2,
})

export const PlatformBadge = styled('a')({
  fontFamily: 'Alexandria',
  fontWeight: 400,
  fontSize: '13px',
  lineHeight: '15.85px',
  letterSpacing: '1.63px',
  textAlign: 'center',
  backgroundColor: '#ffffff',
  borderRadius: '50px',
  padding: '6px 20px',
  display: 'flex',
  alignItems: 'center',
  gap: '8px',
  color: '#000000',
  textDecoration: 'none',
  '& .platform-arrow': {
    marginLeft: '4px',
  },
})

export const DateText = styled(Typography)({
  color: '#dbdbdb',
  fontSize: '16px',
  fontWeight: 500,
})

export const ProfileImage = styled('img')({
  width: '40px',
  height: '40px',
  borderRadius: '50%',
})

export const CardImage = styled(Box)({
  position: 'relative',
  width: '100%',
  height: '349px',
  backgroundSize: 'cover',
  backgroundPosition: 'center',
  '@media (max-width: 600px)': {
    height: 'auto',
    aspectRatio: '1',
  },
})

export const HashTag = styled(Typography)({
  color: '#00D1FF',
  fontSize: '13px',
  fontWeight: 700,
  padding: '5px 30px',
  backgroundColor: 'rgba(0, 209, 255, 0.1)',
  borderRadius: '50px',
  display: 'inline-block',
  letterSpacing: '1.63px',
})

export const CardContent = styled(Box)({
  padding: '12px 20px',
  backgroundColor: '#ffffff',
})

export const ContentText = styled(Typography)({
  fontSize: '15px',
  lineHeight: 1.4,
  color: '#333333',
  wordBreak: 'break-all',
})

export const CardFooter = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  padding: '7px 10px',
  backgroundColor: 'rgba(255, 255, 255, 0.9)',
  borderTop: '1px solid rgba(0, 0, 0, 0.1)',
})

export const SocialStats = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  gap: '16px',
  '& .stat': {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    color: '#000000',
    fontSize: '15px',
    fontWeight: 400,
  },
})

export const ReplyButton = styled(Button)({
  backgroundColor: '#000000',
  color: '#ffffff',
  borderRadius: '50px',
  padding: '2px 34px',
  fontSize: '17px',
  fontWeight: 400,
  textTransform: 'uppercase',
  display: 'flex',
  alignItems: 'center',
  gap: '8px',
  '&:hover': {
    backgroundColor: '#333333',
  },
  '&.replied': {
    backgroundColor: 'transparent',
    color: '#00954b',
    fontWeight: 700,
    fontSize: '13px',
    letterSpacing: '1.63px',
    fontFamily: 'Albert Sans',
    boxShadow: 'none',
  },
  '& img': {
    width: '13px',
    height: '11px',
    objectFit: 'contain',
  },
})

export const ReplyIcon = styled('img')({
  width: '13px',
  height: '11px',
  objectFit: 'contain',
})

export const VideoCard = styled(Box)({
  position: 'relative',
  borderRadius: '24px',
  overflow: 'hidden',
  backgroundColor: '#000000',
  width: '100%',
  maxWidth: '349px',
  height: '604px',
  boxShadow: '4px 8px 20px 0px #FFFFFF40',
  '@media (max-width: 600px)': {
    maxWidth: '100%',
    height: 'min(604px, 80vh)',
  },
})

export const VideoContainer = styled(Box)({
  position: 'absolute',
  top: 0,
  left: 0,
  width: '100%',
  height: '100%',
  borderRadius: '24px',
  '& video': {
    width: '100%',
    height: '100%',
    objectFit: 'cover',
  },
})

export const VideoOverlay = styled(Box)({
  position: 'absolute',
  top: 0,
  left: 0,
  width: '100%',
  height: '100%',
  background:
    'linear-gradient(to bottom, rgba(0,0,0,0.4) 0%, transparent 30%, transparent 60%, rgba(0,0,0,0.8) 100%)',
  zIndex: 1,
})

export const VideoHeader = styled(Box)({
  position: 'absolute',
  top: 0,
  left: 0,
  right: 0,
  padding: '16px',
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  zIndex: 2,
})

export const PlayButton = styled(Box)({
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: '80px',
  height: '80px',
  borderRadius: '50%',
  backgroundColor: 'rgba(255, 255, 255, 0.9)',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  cursor: 'pointer',
  zIndex: 2,
  '& svg': {
    color: '#4B4DED',
  },
  '&:hover': {
    backgroundColor: '#ffffff',
  },
})

export const VideoContent = styled(Box)({
  position: 'absolute',
  bottom: 50, // Adjust to leave space for footer
  left: 0,
  right: 0,
  padding: '6px 20px',
  zIndex: 2,
})

export const VideoFooter = styled(Box)({
  position: 'absolute',
  bottom: 0,
  left: 0,
  right: 0,
  padding: '7px 10px',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  zIndex: 2,
  backgroundColor: '#ffffffd9',
})

export const VideoPlatformBadge = styled(PlatformBadge)({
  backgroundColor: 'rgba(255, 255, 255, 0.9)',
  fontSize: '13px',
  fontWeight: 400,
  lineHeight: '15.85px',
  letterSpacing: '1.63px',
  textAlign: 'center',
})

export const VideoHashTag = styled(Typography)({
  color: '#00D1FF',
  textShadow: '0 2px 4px rgba(0,0,0,0.3)',
  fontSize: '13px',
  fontWeight: 700,
  padding: '5px 30px',
  backgroundColor: 'rgba(0, 209, 255, 0.1)',
  borderRadius: '50px',
  display: 'inline-block',
  letterSpacing: '1.63px',
})

export const VideoContentText = styled(Typography)({
  color: '#ffffff',
  textShadow: '0 2px 4px rgba(0,0,0,0.3)',
  fontSize: '15px',
  lineHeight: 1.4,
  wordBreak: 'break-all',
})

// export const InstagramEmbedWrapper = styled(Box)`
//   // .instagram-media.instagram-media-rendered.Embed {
//   //   display: none !important;
//   // }
// `
